import ItemCounter from './ItemCounter';

export default function OrderItemOption({ 
    increase, 
    decrease, 
    option, 
    activate, 
    fundraiserId,
    bundleSelected = false,
    getBundleQuantity,
    showBundleInfo = false
}) {
    const itemOptionImage = {
        width: 'auto',
        height: 'auto',
        objectFit: 'contain'
    };
    const isPreviewAvailable = option.itemOptionTypeId > 0;

    const windowWidthAdjustment = window.innerWidth <= 400 ? 0.1 : 0;

    const previewButtonStyle = {
        fontSize: `${0.8 - windowWidthAdjustment}rem`,
        padding: `${0.2 - windowWidthAdjustment}rem ${0.5 - windowWidthAdjustment}rem`,
        marginTop: `${0.5 - windowWidthAdjustment}rem`,
    };

    const openPreview = () => window.open(`TicketPreview/${fundraiserId}`, "_blank");

    const priceStyle = {
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'right',
        height: '100%' // Adjust if needed to ensure full height of the container
    };

    // Calculate bundle and extra quantities if bundle is selected
    const bundleQty = (bundleSelected && getBundleQuantity) ? getBundleQuantity(option.itemOptionId) : 0;
    const extraQty = option.qty - bundleQty;
    const hasExtraItems = extraQty > 0;

    // Style for highlighting items based on bundle/selection status
    const getListItemStyle = () => {
        if (!showBundleInfo) return {};
        
        if (bundleQty > 0) {
            // Item is included in bundle - use complete bundle highlight color (light green)
            return {
                backgroundColor: '#d4edda', // Same as complete bundle background
                border: '2px solid #28a745', // Same as complete bundle border
                borderRadius: '8px',
                marginBottom: '0.5rem'
            };
        } else if (option.qty > 0) {
            // Item is additional (not in bundle) but selected - darker background with thicker border
            return {
                backgroundColor: '#e2e3e5', // Darker gray background
                border: '3px solid #6c757d', // Thicker, darker border
                borderRadius: '8px',
                marginBottom: '0.5rem'
            };
        }
        
        return {}; // No special styling for unselected items
    };
    
    const listItemStyle = getListItemStyle();

    return (
        <div>
            <li className="list-group-item d-flex justify-content-between lh-sm" style={listItemStyle}>
                <div className="col-3 d-flex flex-column">
                    <img
                        style={itemOptionImage}
                        onClick={() => activate(option.imgUrl)}
                        src={`https://fundraising-u-production.s3.amazonaws.com/${option.imgUrl}`}
                        alt="itemOptionImage"
                    />
                    {isPreviewAvailable && (
                        <button
                            type="button"
                            className="btn btn-danger"
                            style={previewButtonStyle}
                            onClick={openPreview}
                        >
                            Preview
                        </button>
                    )}
                </div>
                <div className="col-3 d-flex flex-column">
                    <h6 className="my-0 text-left">
                        {option.name}
                        {showBundleInfo && bundleQty > 0 && (
                            <small className="text-success d-block">
                                {bundleQty} in bundle
                                {hasExtraItems && ` + ${extraQty} extra`}
                            </small>
                        )}
                        {showBundleInfo && bundleQty === 0 && option.qty > 0 && (
                            <small className="text-dark fw-bold d-block">
                                {option.qty} additional
                            </small>
                        )}
                    </h6>
                </div>
                <span className="text-muted px-2 col-2" style={priceStyle}>
                    ${option.price}
                </span>
                <ItemCounter className="col-2"
                    increaseCount={increase}
                    decreaseCount={decrease}
                    quantity={option.qty}
                />
            </li>
        </div>
    );
}
